import { useState } from "react";
import { Star } from "lucide-react";

// 1-5 clickable stars with a "why" tooltip. `reasons` come from the programmatic rater ("8 lines · 2 ifs").
export function StarRating({ value = 0, reasons = [], source, onChange, testId = "stars" }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value || 0;
  const why = value
    ? `${value}★ · ${(reasons || []).join(" · ") || (source === "manual" ? "set by admin" : "auto-rated")}${source === "manual" ? " (admin)" : ""}`
    : "Unrated - click a star to set, or use Auto-rate";
  return (
    <span
      className="inline-flex items-center gap-0.5"
      role={onChange ? "radiogroup" : undefined}
      aria-label={why}
      title={why}
      onMouseLeave={() => setHover(0)}
      data-testid={testId}
      data-value={value || 0}
      data-source={source || (value ? "auto" : "none")}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!onChange}
          onMouseEnter={() => onChange && setHover(n)}
          onClick={(e) => { e.stopPropagation(); onChange?.(n); }}
          className={`p-0 leading-none ${onChange ? "cursor-pointer" : "cursor-default"}`}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          data-testid={`${testId}-${n}`}
        >
          <Star className={`w-3.5 h-3.5 transition-colors ${n <= shown ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"} ${hover && n <= hover ? "scale-110" : ""}`} />
        </button>
      ))}
      {!value && <span className="ml-1 text-[11px] text-muted-foreground" data-testid={`${testId}-unrated`}>unrated</span>}
      {value > 0 && source === "manual" && <span className="ml-1 text-[10px] text-muted-foreground" title="Set by an admin">admin</span>}
    </span>
  );
}
